module.exports = __webpack_public_path__ + "img/bzhcp.211f9050.png";